import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { mainApiUrl } from '@constants'
import { prepareHeaders } from '@src/reduxjs'

const cartsApi = createApi({
  reducerPath: 'cartsApi',
  baseQuery: fetchBaseQuery({ baseUrl: mainApiUrl, prepareHeaders }),
  tagTypes: ['Carts'],
  endpoints: (builder) => ({
    get: builder.query({
      query: ({ page, perPage, search }) => {
        const params = {}

        if (page) {
          params.page = page
        }

        if (perPage) {
          params.per_page = perPage
        }

        if (search) {
          params.search = search
        }

        return { url: 'carts', params }
      },
      providesTags: (results) => {
        if (!results) {
          return [{ type: 'Carts', id: 'LIST' }]
        }
        return [...results.data.map((i) => ({ type: 'Carts', id: i.id })), { type: 'Carts', id: 'LIST' }]
      },
    }),
    delete: builder.mutation({
      query: ({ id }) => ({ url: `carts/${id}`, method: 'DELETE' }),
      async onQueryStarted({ id, getQueryParams }, { dispatch, queryFulfilled }) {
        dispatch(cartsApi.util.updateQueryData('get', getQueryParams, (draft) => {
          draft.data = draft.data.filter(i => i.id !== id)
        }))

        try {
          await queryFulfilled
        } catch {
          dispatch(cartsApi.util.invalidateTags(['Carts']))
        }
      },
    }),
    dispatchCart: builder.mutation({
      query: ({ id, method }) => {
        return {
          url: `carts/${id}/dispatch`,
          method: 'POST',
          body: { method },
        }
      },
    }),
    updateCart: builder.mutation({
      query: (data) => {
        return {
          url: `carts/${data.id}`,
          method: 'PATCH',
          body: data,
        }
      },
    }),
  }),
})

export const { useGetQuery, useUpdateCartMutation, useDispatchCartMutation, useDeleteMutation } = cartsApi

export default cartsApi
